import { OrderType } from 'apiConnector/secondary-market/batch/model';
import { useAppSelector } from 'hooks/useAppSelector';
import { useDispatch } from 'react-redux';
import { getAvailableOrderTypes, getDefaultOrderType } from 'state/selectors/meta/secondary-market';
import { secondaryMarketBatchActions } from 'state/workspaces/secondary-market/batch/actions';
import { selectOrderType } from 'state/workspaces/secondary-market/batch/selectors';

export function useOrderType() {
  const dispatch = useDispatch();
  const orderType = useAppSelector(selectOrderType);
  const availableOrderTypes = useAppSelector(getAvailableOrderTypes);
  const defaultOrderType = useAppSelector(getDefaultOrderType);
  const resolvedOrderType = availableOrderTypes.includes(orderType) ? orderType : (defaultOrderType ?? orderType);
  const setOrderType = (orderType: OrderType) => {
    dispatch(secondaryMarketBatchActions.orderTypeChange(orderType));
  };

  return {
    orderType: resolvedOrderType,
    setOrderType,
  };
}
